"use strict";

$(document).ready(function () {
  var isIE =
  /*@cc_on!@*/
  false || !!document.documentMode;
  /**
   * Get language from URL
   */

  var urlParams = new URLSearchParams(window.location.search);
  var lang = urlParams.get('lang');
  /**
   * If language is not set in URL, set default cs
   */

  if (lang === null) {
    lang = 'cs';
  }
  /**
   * Get an array of all ids in document with prefix 'lang' and set data according to actual language
   */


  var idsArray = document.querySelectorAll('[id]');
  Array.prototype.forEach.call(idsArray, function (element, i) {
    if (element.id.includes('lang')) {
      window[element.id].innerHTML = language[lang][element.id];
    }
  });
  /**
   * Load data from API and initialize data if browser is not IE
   */

  if (!isIE) {
    var loadedData;
    var loading = $('#promotions > .load');
    loading.addClass('loading');

    var loadDataSuccessCallback = function loadDataSuccessCallback() {
      var categories = new CategoriesController(loadedData);
      var products = new ProductsController(loadedData, categories, lang);
      var promotions = new PromotionsController(loadedData);
      loading.removeClass('loading');
    };

    loadedData = new LoadDataController(loadDataSuccessCallback, lang);
  } else {
    $('body').html('<div style="text-align: center;margin-top:3em;"><h2>Váš prohlížeč není momentálně podporován.</h2><h3>Tato stránka je plně funkční na Chrome, Firefox, Safari, Opera a EDGE.</h3></div>');
  }
});